module.exports = __webpack_public_path__ + "static/img/9.bb6c245.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/eng/9.png
// module id = MMzL
// module chunks = 0